export default "https://cdn-static.gokick.com/assets/1a6b0e419037e7f05bc52ad73a019b5bb7bc4745/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";